/*
 * Copyright 2026 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.core.model.session

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Session(
    val id: String,
    @SerialName("patient_id")
    val patientId: String,
    @SerialName("session_date")
    val sessionDate: String,
    val fee: Long,
    @SerialName("session_type")
    val sessionType: SessionType = SessionType.REGULAR,
    @SerialName("payment_status")
    val paymentStatus: PaymentStatus = PaymentStatus.PENDING,
    @SerialName("amount_paid")
    val amountPaid: Long = 0,
    @SerialName("schedule_id")
    val scheduleId: String? = null,
    @SerialName("session_status")
    val sessionStatus: SessionStatus = SessionStatus.CONFIRMED,
    @SerialName("created_at")
    val createdAt: String,
)
